import React, { useCallback, useEffect, useRef, useState } from "react";
import "./index.less";
import { Button } from "antd";
import { useNavigate } from "react-router";
import { checkActiviteSignup, getActivityDetail } from "@/api/activite";
import messageDispatchCenter from "@/utils/messageDispatchCenter";
import { MESSAGE_ON_TYPE, QuestionStatus } from "@/types/message";
import { getServiceVal } from "@/utils/cookies";
const prefix = "system-activite";

const deviceConfigList:any[]=[
  ['序号','硬件','要求'],
  ['1','CPU','1 GHz或更快的支持64位的处理器（双核或多核）或系统单芯片(SoC)。'],
  ['2','RAM','4 GB或更大的RAM'],
  ['3','存储','30GB或更大的存储设备，支持SATA、NVME'],
  ['4','系统固件','支持从外部USB引导的UEFI系统固件'],
  ['5','显卡','OpenGL ES 3.0或更高版本的显卡'],
  ['6','显示设备','分辨率至少为800x600的VGA设备，后续版本支持HDMI/DP设备'],
  ['7','输入输出设备','符合HID标准的输入输出设备'],
  ['8','网络设备','以太网卡/支持Wi-Fi直连的Wi-Fi适配器/蓝牙版本为4.0及以上的设备'],
  ['9','音频设备','兼容HDAudio标准的音频适配器'],
  ['10','USB','USB 3.0/2.0']
]
const SystemActivite: React.FC = () => {
  const navgiate = useNavigate();
  const activiteRef=useRef<any>(null);
  const signupBtnStatus=useRef<boolean[]>([false]);
  const [isSignup, setIsSignup] = useState<any>(0);
  const [activeTab, setActiveTab] = useState<string>("");
  const activeTabRef = useRef<string>("");
  const timerRef = useRef<any>(null);
  const code = "KaihongOS_x86_Beat";
  const bannerBtnClick = useCallback(() => {
    navgiate("/activity/x86-beta/signup?code=" + code);
  }, []);
  const [activiteDetail, setActiviteDetail] = useState<any>({});
  const headerTabs = useRef<any>([
    {
      id: "signup-intro",
      name: "活动介绍",
    },
    {
      id: "signup-process",
      name: "招募流程",
    },
    {
      id: "signup-tip",
      name: "温馨提示",
    },
  ]);
  /**
   * 校验是否已经报名
   * @returns 
   */
  const checkActiviteSignupStatus=()=>{
    return new Promise((resolve,reject)=>{
      signupBtnStatus.current[1]=false;
      checkActiviteSignup(code).then((res)=>{
        console.log(res);
        if(res.code==200){
          setIsSignup(res.result);
          resolve(res.result);
        }else{
          reject(res.message);
        }
      }).catch((err)=>{
        console.error(err)
        reject(err)
      }).finally(()=>{
        signupBtnStatus.current[1]=true;
      })
    })
  }
  const changeTab = (id: string) => {
    if(activeTabRef.current==id) return;
    setActiveTab(id);
    activeTabRef.current=id;
  };
  const headerTabClick = useCallback(
    /**
     * tab点击滚动
     * @param id 
     * @returns 
     */
    (id: string) => {
    console.log(id);
    if(activeTabRef.current==id) return;
    const dom = document.getElementById(id);
    if (dom) {
      dom.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
      changeTab(id);
    }
  }, []);
  const observerHandle=useCallback(
    /**
     * 滚动监听处理  限流
     * @param e 
     * @returns 
     */
    (e:any)=>{
    if(timerRef.current){
      clearTimeout(timerRef.current);
      timerRef.current=null;
    }
    timerRef.current=setTimeout(()=>{
      let id=headerTabs.current[0].id;
      headerTabs.current.forEach((item:any) => {
        const dom = document.getElementById(item.id+'-box');
        if (dom) {
          const domRect = dom.getBoundingClientRect();
          const maxTop=window.innerWidth>1920?window.innerWidth/1920*180:180;
          if(domRect.top<maxTop){
            id=item.id;
          }
        }

      });
      console.log('zzz');
      if(id){
        changeTab(id);
      }
      timerRef.current=null;
    },200)
   
  },[])
    const submitText=()=>{
      let str='';
      if(activiteDetail?.status==QuestionStatus.IN_PROGRESS){
        str= isSignup?"已报名" : "立即报名";
      }else if(activiteDetail?.status==QuestionStatus.END){
        str='活动已结束'
      }else if(activiteDetail?.status==QuestionStatus.NOT_START){
        str='活动未开始'
      }else{
        str='立即报名'
      }
      return str
    }

      const getActivite=()=>{
        signupBtnStatus.current[0]=false;
        getActivityDetail(code ).then((res)=>{
          console.log(res);
          if(res.code==200){
            setActiviteDetail(res.result)
          }
        }).catch((err)=>{
          console.error(err)
        }).finally(()=>{
          signupBtnStatus.current[0]=true;
        })
      }

  const signupBtnDisabled=activiteDetail?.status!=QuestionStatus.IN_PROGRESS || isSignup;
  useEffect(() => {
    // 监听滚动事件
    messageDispatchCenter.on(MESSAGE_ON_TYPE.SCROLL,observerHandle);
    getActivite();
    if(getServiceVal('Authorization')){
      checkActiviteSignupStatus();
    }

    return () => {
      messageDispatchCenter.off(MESSAGE_ON_TYPE.SCROLL,observerHandle);
      clearTimeout(timerRef.current);
      timerRef.current=null;
    };
  },[])
  return (
    <div ref={activiteRef} className={`${prefix}`}>
      <div key={1} className={`${prefix}-banner`}>
        <img src={require("../../../assets/images/activite-banner.png")} alt="" />
        <div className={`${prefix}-banner-content`}>
          <h1>KaihongOS桌面版成功适配x86设备诚邀开发者 Beta体验</h1>
          <p>报名开启，不容错过</p>
          
          {
            signupBtnStatus.current.every(item=>item===true) && <Button onClick={bannerBtnClick} disabled={signupBtnDisabled} type="primary">
            {submitText()}
          </Button>
          }
        </div>
      </div>
      <div className={`${prefix}-signup-header`}>
        <div className={`${prefix}-signup-header-tab`}>
          {headerTabs.current.map((item: any) => {
            return (
              <div key={item.id} onClick={() => headerTabClick(item.id)} className={`${prefix}-signup-header-tab-item flex-center ${item.id === activeTab ? "active" : ""}`}>
                {item.name}
              </div>
            );
          })}
        </div>
        <div className={`${prefix}-signup-header-btn`}>
          {
            signupBtnStatus.current.every(item=>item===true) ? <Button onClick={bannerBtnClick} disabled={signupBtnDisabled} type="primary">
            {submitText()}
            </Button>:<div className="space">

            </div>
          }
        </div>
      </div>
      <div className={`${prefix}-content`}>
        <div data-id={"signup-intro"} id={'signup-intro-box'} className={`${prefix}-content-intro signup-section`}>
          <div className="signup-section-position" id="signup-intro"></div>
          <h2>活动介绍</h2>
          <p>国内首个开源鸿蒙桌面操作系统——KaihongOS桌面版，成功适配x86设备，为国产操作系统的发展开辟了新路径。我们诚邀您参与本次体验计划，深度体验KaihongOS桌面版，包括系统安装、卸载，以及开源鸿蒙原生应用体验，全方位感受系统的独特魅力。您的反馈将帮助我们优化系统，打造更稳定、高效、用户友好的桌面体验。</p>
          <p> ⏰ 报名时间</p>
          <p>报名周期：06月30日- 07月15日</p>
          <p>审核周期：07月10日- 07月30日，具体请以实际审核时间为准，请您耐心等待。 后续报名开放情况，请关注官方消息。</p>
        </div>
        <div data-id={"signup-process"} id={'signup-process-box'} className={`${prefix}-content-process signup-section`}>
          <div className="signup-section-position" id="signup-process"></div>
          <h2>招募流程</h2>

          <div className={`${prefix}-content-process-step`}>
          <div className={`${prefix}-content-process-step-box`}>
              <div className={`${prefix}-content-process-step-header`}>
                <div className="num">1</div>
                <div className="line"></div>
              </div>
              
              <div className={`${prefix}-content-process-step-des`}>
              <h3>社区注册</h3>
              <p>本次招募活动仅面向开发者开放，开发者可点击网页右上方“登录”进行注册。 如果您已经完成注册，可以直接进入下一步。</p>
              </div>
            </div>
            <div className={`${prefix}-content-process-step-box`}>
              <div className={`${prefix}-content-process-step-header`}>
                <div className="num">2</div>
                <div className="line"></div>
              </div>
              
              <div className={`${prefix}-content-process-step-des`}>
              <h3>活动报名</h3>
              <p>点击页面上方“立即报名”，填写Beta活动的申请信息后，方可获得本次招募活动的报名资格并进入审核阶段。 审核结果将以官方邮件（或短信）进行通知，请您耐心等待。</p>
              </div>
            </div>

            <div className={`${prefix}-content-process-step-box`}>
              <div className={`${prefix}-content-process-step-header`}>
                <div className="num">3</div>
              </div>
              <div className={`${prefix}-content-process-step-des`}>
              <h3>获得体验license及部分资源</h3>
              <p>审核通过后，您将获得KaihongOS桌面版镜像包、license激活码等（定向推送）。 7月10日起陆续进行版本推送，预计7月下旬全部推送完毕。</p>
              </div>
             
            </div>
          </div>
        </div>
        <div data-id={"signup-tip"} id={'signup-tip-box'} className={`${prefix}-content-tip signup-section`}>
          <div className="signup-section-position" id="signup-tip"></div>
          <h2>温馨提示</h2>
          <p>1. 数据备份提醒：本次升级为Beta版本，主要供开发者进行应用调测使用，因此在进行烧录前，请务必通过PC备份、云端备份等功能做好设备数据备份。</p>
          <p>2. 系统体验需遵守保密协议，禁止私自传播系统镜像。</p>
          <p>3. 由于本次Beta招募主要面向开发者，且招募名额有限，若很遗憾未能通过本次审核，感谢您的参与，期待与您下次合作。</p>
          <p>4. 支持设备/硬件要求</p>
          <div className="signup-device-config">
            {
              deviceConfigList.map((item: any, index: number) => {
                return (
                  <div key={index} className="signup-device-config-item">
                    {
                      item.map((item2: any, index2: number) => {
                        return (
                          <div key={index+'-'+index2} className="signup-device-config-item-box">
                            {item2}
                          </div>
                        )
                      })
                    }
                  </div>
                )
              })
            }
          </div>
        </div>

        <div className={`${prefix}-content-call signup-section`}>
          <h2>联系我们</h2>
          <img src={require('@/assets/images/activite-code.png')} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SystemActivite;
